export const brands = {
  noddi: 'noddi',
  bestdrive: 'bestdrive',
  tronderdekk: 'tronderdekk',
  carglass: 'carglass',
  dekkstra: 'dekkstra',
  dekkfix: 'dekkfix',
  elitebilvask: 'elitebilvask',
  dekkteam: 'dekkteam',
  shine: 'shine',
  lotus: 'lotus',
  myldre: 'myldre',
  meks: 'meks'
} as const;

export type BrandType = keyof typeof brands;

export const brandLabels = {
  [brands.noddi]: 'Noddi',
  [brands.bestdrive]: 'BestDrive',
  [brands.tronderdekk]: 'Trønderdekk',
  [brands.carglass]: 'Hurtigruta carglass',
  [brands.dekkstra]: 'Dekkstra',
  [brands.dekkfix]: 'Dekkfix',
  [brands.elitebilvask]: 'Elite Bilvask',
  [brands.dekkteam]: 'DekkTeam',
  [brands.shine]: 'Shine',
  [brands.lotus]: 'Lotus',
  [brands.myldre]: 'Myldre',
  [brands.meks]: 'MEKS'
};

export const brandWindowTitles = {
  [brands.noddi]: 'Noddi',
  [brands.bestdrive]: 'BestDrive',
  [brands.tronderdekk]: 'Tronderdekk',
  [brands.carglass]: 'Carglass',
  [brands.dekkstra]: 'Dekkstra',
  [brands.dekkfix]: 'Dekkfix',
  [brands.elitebilvask]: 'Elite Bilvask',
  [brands.dekkteam]: 'DekkTeam',
  [brands.shine]: 'Shine',
  [brands.lotus]: 'Lotus',
  [brands.myldre]: 'Myldre',
  [brands.meks]: 'MEKS'
};
